import React from 'react';
import ConfigureStep from '../onboard/ConfigureStep';

interface ConfigureChannelStepProps {
  protocol: 'a2a' | 'ap2' | 'mcp';
  channelConfig: any;
  configureFormState: any;
  onConfigChange: (config: any, formState?: any) => void;
  onBack: () => void;
}

const ConfigureChannelStep: React.FC<ConfigureChannelStepProps> = ({
  protocol,
  channelConfig,
  configureFormState,
  onConfigChange,
  onBack,
}) => {
  // For A2A and MCP, use the onboarding ConfigureStep
  const handleConfigurationComplete = (config: any, formState: any) => {
    onConfigChange(config, formState);
  };

  return (
    <ConfigureStep
      protocol={protocol}
      capturedPayload={null}
      derivedSchema={null}
      initialFormState={configureFormState}
      onConfigurationComplete={handleConfigurationComplete}
      onBack={onBack}
    />
  );
};

export default ConfigureChannelStep;
